// extracted by mini-css-extract-plugin
export default {"name":"Header_name__Lm0JM","code":"Header_code__TXAHC","item":"Header_item__aZx3c"};